export const sshKeyHandler = {
  type: "ssh-key",
  envelope: { single: "sshkey", collection: "sshkeys" },
  relationships: {
    project: { type: "project", key: "account" },
  },
};
